import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "translation/useTranslation";
import { Button, Field, Input, NativeSelect } from "components/ui";

export default function AbsenceDaysReductionFactor({ register, watch, handleSubmit, onSubmit }) {
  const dispatch = useDispatch();

  const { translate, editableTranslate } = useTranslation();

  const enabledProrate = watch('prorate_enabled');

  const [showProrateSettings, setShowProrateSettings] = useState(false);

  useEffect(() => {
    if (enabledProrate) {
      setShowProrateSettings(true);
    } else {
      setShowProrateSettings(false);
    }
  }, [enabledProrate]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-md-12">
          <div className="form-row">
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_working_days_per_week')}>
                <Input type="number" number min={0} max={5} step={1} placeholder="0-5" {...register('employee_working_days_per_week')} data-testid="employee-working-days-per-week-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_absence_days')}>
                <Input type="number" number min={0} max={365} step={1} placeholder="0-365" {...register('employee_absence_days')} data-testid="employee-absence-days-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.budget_working_days')}>
                <Input type="number" number min={0} max={365} step={1} placeholder="0-365" {...register('budget_working_days')} data-testid="budget-working-days-input" />
              </Field>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value={true} {...register('prorate_enabled')} data-testid="prorate-enabled-checkbox" />
                <label className="form-check-label ml-1">
                  {editableTranslate('calculation.debugger.enabled_prorate')}
                </label>
              </div>
            </div>
          </div>
          {
            showProrateSettings &&
            <>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.prorate_day_threshold')}>
                    <Input type="number" number {...register('prorate_day_threshold')} data-testid="prorate-day-threshold-input" />
                  </Field>
                </div>
                <div className="form-group col-md-3">
                  <Field label={editableTranslate('calculation.debugger.prorate_day_threshold_type')}>
                    <NativeSelect {...register('prorate_day_threshold_type')} data-testid="prorate-day-threshold-type-select">
                      <option value={'percent'}>% (percentage)</option>
                      <option value={'absolute'}>days</option>
                    </NativeSelect>
                  </Field>
                </div>
              </div>
            </>
          }
          <div className="form-row">
            <div className="form-group col-md-6">
              <Button type="submit" variant="primary" data-testid="submit-button">Submit</Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
